export default "../css/d20afa1011c50ff58c532d946560b0b7.ttf";